import React, { cloneElement } from 'react'
import { TestingButton } from '../TestingButton/TestingButton'
import { LayoutGroup } from 'framer-motion'
import logger from '../../../utils/logger'
import { LoadingComponent2 } from '../LoadingComponent/loadingComponent2/LoadingComponent2';
import { EmptyDataComponent } from '../EmptyData/EmptyDataComponent';

// export const ArrayRender = ({ layoutRender, data}) => {

//    logger.debug('ArrayRender DATA: ', data)


//     return (
//         <>

//            { cloneElement(layoutRender, { data })}

//         </>
//     )
// }


// export const ArrayRender = ({ layoutRender, data, totalFiltered }) => {
//     logger.debug('ArrayRender DATA: ', data);

//     return (
//         <>
//             {data && data?.items?.length > 0 ? (
//                 cloneElement(layoutRender, { data }) // Removidas las llaves extras
//             ) : (
//                 <p>Haz Una Busqueda 😁</p>
//             )}
//         </>
//     );
// };




export const ArrayRender = ({ layoutRender, data, totalFiltered, loading }) => {
    logger.debug('ArrayRender DATA: ', data);

    return (

        <>

            {!loading ?

                <>
                    {(() => {
                        // 1. Si hay items, renderizamos el layout
                        if (data?.items?.length > 0) {
                            return cloneElement(layoutRender, { data });
                        }

                        // 2. Si totalFiltered es 0, significa que se buscó y no hubo resultados
                        if (totalFiltered === 0) {
                            // return <p>No se encontraron resultados</p>;
                            return <EmptyDataComponent 
                            message={'No se encontraron formaciones'}
                            icon={'search_off'}
                            />
                        }

                        // 3. Caso por defecto (totalFiltered es null o no hay datos aún)
                        // return <p>Haz Una Busqueda 😁</p>;
                        return <EmptyDataComponent
                         message={'Realice una búsqueda para empezar'}
                         icon={'search'}
                         />
                    })()}
                </>
                :

                <LoadingComponent2
                    className={'min-heigth-auto'}

                />

            }

        </>


    );
};